import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'orgEntityId',
                },
                'ent:!org:!dept',
              ],
            },
            'Subdepartments',
          ],
          [
            {
              '=': [
                {
                  '@$': 'orgEntityIdSegment',
                },
                'ent:!org:!dept',
              ],
            },
            'Subdepartments',
          ],
          'Departments',
        ],
      },
      type: 'table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'organizations',
                },
              },
              subqueries: {
                organizations: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdc',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdc',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'mtdcDensity',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'mtdcDensity',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityId',
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityIdSegment',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'asf',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'asf',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': [
                                          {
                                            '@>': '$selection',
                                          },
                                          'fields',
                                        ],
                                      },
                                      'effectiveRecovery',
                                    ],
                                  },
                                  'value',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': [
                                            {
                                              '@>': '$selection',
                                            },
                                            'fields',
                                          ],
                                        },
                                        'effectiveRecovery',
                                      ],
                                    },
                                    'value',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          asf: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          tdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          mtdc: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                          projects: {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '#': {
                                      '@': 'projects',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          totalSqft: {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          tdcDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '??': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            1,
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'tdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                  ],
                                  {
                                    '/': [
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projects',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'tdc',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          0,
                                        ],
                                      },
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          1,
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                          mtdcDensity: {
                            '{}': {
                              value: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '??': [
                                            {
                                              '+': {
                                                '->': [
                                                  {
                                                    '@': 'rooms',
                                                  },
                                                  {
                                                    '@>': [
                                                      {
                                                        '@$': '$value',
                                                      },
                                                      'asf',
                                                    ],
                                                  },
                                                ],
                                              },
                                            },
                                            1,
                                          ],
                                        },
                                        0,
                                      ],
                                    },
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'projects',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'mtdc',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        0,
                                      ],
                                    },
                                  ],
                                  {
                                    '/': [
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'projects',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'mtdc',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          0,
                                        ],
                                      },
                                      {
                                        '??': [
                                          {
                                            '+': {
                                              '->': [
                                                {
                                                  '@': 'rooms',
                                                },
                                                {
                                                  '@>': [
                                                    {
                                                      '@$': '$value',
                                                    },
                                                    'asf',
                                                  ],
                                                },
                                              ],
                                            },
                                          },
                                          1,
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          },
                          utilization: {
                            '{}': {
                              value: {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'sqft',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                      onClick: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgEntityIdSegment',
                                  },
                                },
                                'ent:!org:!dept',
                              ],
                            },
                            null,
                          ],
                          {
                            '{}': {
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          segmentId: 'org',
                                          variables: {
                                            if: [
                                              [
                                                {
                                                  '=': [
                                                    {
                                                      '``': {
                                                        '@$': 'piRecordId',
                                                      },
                                                    },
                                                    null,
                                                  ],
                                                },
                                                {
                                                  '{}': {
                                                    orgRecordId: {
                                                      '@.': '!id',
                                                    },
                                                    orgEntityIdSegment: {
                                                      '@_': 'id',
                                                    },
                                                  },
                                                },
                                              ],
                                              {
                                                '{}': {
                                                  piRecordId: {
                                                    '``': {
                                                      '@$': 'piRecordId',
                                                    },
                                                  },
                                                  orgRecordId: {
                                                    '@.': '!id',
                                                  },
                                                  orgEntityIdSegment: {
                                                    '@_': 'id',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-link',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              orgEntityId: {
                                                '@_': 'id',
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    rooms: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      using: 'orgSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@.': '!sqft',
                              },
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '*': [
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'value',
                                              ],
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'allowable',
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '{}': {
                              value: {
                                '@.': '!weight',
                              },
                              allowable: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '@': 'funcIdCat',
                                        },
                                        null,
                                      ],
                                    },
                                    1,
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    orgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!org',
                        inherit: '-',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      filter: {
                        not: {
                          '=': [
                            {
                              '@': 'projectPiAssignments',
                            },
                            null,
                          ],
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '{}': {
                          tdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              idcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'IDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              tdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'TDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            costType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!code',
                              },
                            },
                          },
                        },
                        projectPiAssignments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          filter: {
                            and: [
                              {
                                not: {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'piRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'piRecordId',
                                    },
                                  },
                                  {
                                    '@.': [
                                      '!pi',
                                      {
                                        ref: {
                                          entity: '!employee',
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!proj_pis:!entry',
                        },
                        projectPiDepartments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          target: 'ent:!proj_pis:!entry',
                          selection: {
                            '@': 'piDept',
                          },
                          subqueries: {
                            piDept: {
                              ref: {
                                attr: 'attr:ent#!proj_pis#!entry:!pi',
                              },
                              target: 'ent:!personnel:!employee',
                              selection: {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: '!dept',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          query: {
            '`': {
              filter: {
                and: [
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdc',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdc',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'mtdcDensityMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'mtdcDensityMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'mtdcDensity',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'mtdcDensityMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '@_': ['parent', 'id'],
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'orgEntityId',
                              },
                            },
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@_': ['parent', 'id'],
                          },
                          {
                            '`': {
                              '``': {
                                '@$': 'orgEntityIdSegment',
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    '=': [
                      {
                        '@^': 'parent',
                      },
                      {
                        '``': {
                          '@$': 'orgRecordId',
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'asf',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'asfMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'asfMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'asf',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'asfMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        '>=': [
                          {
                            '@>': [
                              {
                                '@>': [
                                  {
                                    '@>': [
                                      {
                                        '@>': '$selection',
                                      },
                                      'fields',
                                    ],
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              'value',
                            ],
                          },
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMin',
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '``': {
                              '@$': 'effectiveRecoveryMax',
                            },
                          },
                          null,
                        ],
                      },
                      {
                        not: {
                          '>=': [
                            {
                              '@>': [
                                {
                                  '@>': [
                                    {
                                      '@>': [
                                        {
                                          '@>': '$selection',
                                        },
                                        'fields',
                                      ],
                                    },
                                    'effectiveRecovery',
                                  ],
                                },
                                'value',
                              ],
                            },
                            {
                              '``': {
                                '@$': 'effectiveRecoveryMax',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                ],
              },
              period: {
                '``': {
                  '@$': 'focusedRange',
                },
              },
              target: 'dim::!org',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'projects',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '??': [
                              {
                                '#': {
                                  '@': 'projects',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        1,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'projects',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'tdc',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'tdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      1,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '??': [
                                        {
                                          '+': {
                                            '->': [
                                              {
                                                '@': 'rooms',
                                              },
                                              {
                                                '@>': [
                                                  {
                                                    '@$': '$value',
                                                  },
                                                  'asf',
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        1,
                                      ],
                                    },
                                    0,
                                  ],
                                },
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'projects',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'mtdc',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    0,
                                  ],
                                },
                              ],
                              {
                                '/': [
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'projects',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'mtdc',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      0,
                                    ],
                                  },
                                  {
                                    '??': [
                                      {
                                        '+': {
                                          '->': [
                                            {
                                              '@': 'rooms',
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'asf',
                                              ],
                                            },
                                          ],
                                        },
                                      },
                                      1,
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'rooms',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'sqft',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                  onClick: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'orgEntityIdSegment',
                              },
                            },
                            'ent:!org:!dept',
                          ],
                        },
                        null,
                      ],
                      {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      segmentId: 'org',
                                      variables: {
                                        if: [
                                          [
                                            {
                                              '=': [
                                                {
                                                  '``': {
                                                    '@$': 'piRecordId',
                                                  },
                                                },
                                                null,
                                              ],
                                            },
                                            {
                                              '{}': {
                                                orgRecordId: {
                                                  '@.': '!id',
                                                },
                                                orgEntityIdSegment: {
                                                  '@_': 'id',
                                                },
                                              },
                                            },
                                          ],
                                          {
                                            '{}': {
                                              piRecordId: {
                                                '``': {
                                                  '@$': 'piRecordId',
                                                },
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                              orgEntityIdSegment: {
                                                '@_': 'id',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                  overflowActions: {
                    '[]': [
                      {
                        '{}': {
                          icon: 'atn-icon atn-link',
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          orgEntityId: {
                                            '@_': 'id',
                                          },
                                          orgRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'explore',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
              subqueries: {
                rooms: {
                  ref: {
                    attr: 'attr:ent#!org_space#!entry:!space',
                  },
                  using: 'orgSpace',
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'spaceEntityId',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '=': [
                              {
                                '@^': {
                                  '``': {
                                    '@$': 'spaceEntityId',
                                  },
                                },
                              },
                              {
                                '``': {
                                  '@$': 'spaceRecordId',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '`': {
                                  '``': {
                                    '@$': 'spaceType',
                                  },
                                },
                              },
                              null,
                            ],
                          },
                          {
                            in: [
                              {
                                '@.': [
                                  '!space_use',
                                  {
                                    ref: {
                                      entity: '!group',
                                    },
                                  },
                                ],
                              },
                              {
                                '@>': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  'ent:!space_use:!group',
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  target: 'ent:!space:!room',
                  selection: {
                    '{}': {
                      asf: {
                        '*': [
                          {
                            '@.': '!sqft',
                          },
                          {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'weights',
                                    },
                                    {
                                      '*': [
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'allowable',
                                          ],
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'weights',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'value',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                      sqft: {
                        '@.': '!sqft',
                      },
                    },
                  },
                  subqueries: {
                    weights: {
                      ref: {
                        attr: 'attr:ent#!space_funcl#!entry:!space',
                        inherit: '-',
                      },
                      filter: {
                        '!=': [
                          {
                            '@.': '!weight',
                          },
                          0,
                        ],
                      },
                      target: 'ent:!space_funcl:!entry',
                      selection: {
                        '{}': {
                          value: {
                            '@.': '!weight',
                          },
                          allowable: {
                            if: [
                              [
                                {
                                  '!=': [
                                    {
                                      '@': 'funcIdCat',
                                    },
                                    null,
                                  ],
                                },
                                1,
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        funcIdCat: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!func_space',
                          },
                          target: 'ent:!func_space:!func',
                          selection: {
                            '@.': [
                              '!func_idc',
                              {
                                ref: {
                                  entity: '!cat',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
                orgSpace: {
                  ref: {
                    attr: 'attr:ent#!org_space#!entry:!org',
                    inherit: '-',
                  },
                  target: 'ent:!org_space:!entry',
                },
                projects: {
                  ref: {
                    attr: 'attr:ent#!projects#!proj:!org',
                    inherit: '-',
                  },
                  filter: {
                    not: {
                      '=': [
                        {
                          '@': 'projectPiAssignments',
                        },
                        null,
                      ],
                    },
                  },
                  target: 'ent:!projects:!proj',
                  selection: {
                    '{}': {
                      tdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'tdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                      mtdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projectGlExpenses',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdcAmount',
                              ],
                            },
                          ],
                        },
                      },
                    },
                  },
                  subqueries: {
                    projectGlExpenses: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '{}': {
                          idcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'IDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          tdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'TDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                          mtdcAmount: {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '@': 'costType',
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@.': '!amount',
                                },
                              ],
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        costType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!code',
                          },
                        },
                      },
                    },
                    projectPiAssignments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      filter: {
                        and: [
                          {
                            not: {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'piRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                          },
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'piRecordId',
                                },
                              },
                              {
                                '@.': [
                                  '!pi',
                                  {
                                    ref: {
                                      entity: '!employee',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!proj_pis:!entry',
                    },
                    projectPiDepartments: {
                      ref: {
                        attr: 'attr:ent#!proj_pis#!entry:!proj',
                      },
                      target: 'ent:!proj_pis:!entry',
                      selection: {
                        '@': 'piDept',
                      },
                      subqueries: {
                        piDept: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!pi',
                          },
                          target: 'ent:!personnel:!employee',
                          selection: {
                            '@.': [
                              '!org',
                              {
                                ref: {
                                  entity: '!dept',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '++': [
              {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!org#!dept:!code',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!org#!dept:!name',
                        },
                      },
                    },
                  },
                ],
              },
              {
                if: [
                  [
                    {
                      '=': [
                        {
                          '@$': 'spaceRecordId',
                        },
                        null,
                      ],
                    },
                    {
                      '[]': [
                        {
                          '{}': {
                            id: 'tdc',
                            direct: {
                              '{}': {
                                name: 'TDC',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'tdcDensity',
                            direct: {
                              '{}': {
                                name: 'TDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdc',
                            direct: {
                              '{}': {
                                name: 'MTDC',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'mtdcDensity',
                            direct: {
                              '{}': {
                                name: 'MTDC Density',
                                type: 'CURRENCY',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'asf',
                            direct: {
                              '{}': {
                                name: 'ASF',
                                type: 'INT',
                              },
                            },
                          },
                        },
                        {
                          '{}': {
                            id: 'projects',
                            direct: {
                              '{}': {
                                name: 'Projects',
                                type: 'INT',
                              },
                            },
                          },
                        },
                      ],
                    },
                  ],
                  {
                    '[]': [
                      {
                        '{}': {
                          id: 'asf',
                          direct: {
                            '{}': {
                              name: 'ASF',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'totalSqft',
                          direct: {
                            '{}': {
                              name: 'Total Area',
                              type: 'INT',
                            },
                          },
                        },
                      },
                      {
                        '{}': {
                          id: 'utilization',
                          direct: {
                            '{}': {
                              name: 'Utilization',
                              type: 'PERCENT',
                            },
                          },
                        },
                      },
                    ],
                  },
                ],
              },
            ],
          },
          totalRow: {
            '`': {
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      asf: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      mtdc: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdc',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: 'Total',
                        },
                      },
                      projects: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'projects',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      totalSqft: {
                        '{}': {
                          value: {
                            '+': {
                              '->': [
                                {
                                  '@': 'records',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'totalSqft',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      tdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'tdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      mtdcDensity: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'mtdc',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'asf',
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        },
                      },
                      utilization: {
                        '{}': {
                          value: {
                            '/': [
                              {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        'utilization',
                                      ],
                                    },
                                  ],
                                },
                              },
                              {
                                '#': {
                                  '@': 'records',
                                },
                              },
                            ],
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdc',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'mtdc',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'mtdcDensity',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'mtdcDensityMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'mtdcDensityMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'mtdcDensity',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'mtdcDensityMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityId',
                                  },
                                },
                              },
                            ],
                          },
                          {
                            '=': [
                              {
                                '@_': ['parent', 'id'],
                              },
                              {
                                '`': {
                                  '``': {
                                    '@$': 'orgEntityIdSegment',
                                  },
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'asf',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'asfMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'asfMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'asf',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'asfMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            '>=': [
                              {
                                '@>': [
                                  {
                                    '@>': '$selection',
                                  },
                                  'effectiveRecovery',
                                ],
                              },
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMin',
                                },
                              },
                            ],
                          },
                        ],
                      },
                      {
                        or: [
                          {
                            '=': [
                              {
                                '``': {
                                  '@$': 'effectiveRecoveryMax',
                                },
                              },
                              null,
                            ],
                          },
                          {
                            not: {
                              '>=': [
                                {
                                  '@>': [
                                    {
                                      '@>': '$selection',
                                    },
                                    'effectiveRecovery',
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'effectiveRecoveryMax',
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    ],
                  },
                  period: {
                    '``': {
                      '@$': 'focusedRange',
                    },
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      asf: {
                        '+': {
                          '->': [
                            {
                              '@': 'rooms',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'asf',
                              ],
                            },
                          ],
                        },
                      },
                      tdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'tdc',
                              ],
                            },
                          ],
                        },
                      },
                      mtdc: {
                        '+': {
                          '->': [
                            {
                              '@': 'projects',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'mtdc',
                              ],
                            },
                          ],
                        },
                      },
                      projects: {
                        '??': [
                          {
                            '#': {
                              '@': 'projects',
                            },
                          },
                          0,
                        ],
                      },
                      totalSqft: {
                        '+': {
                          '->': [
                            {
                              '@': 'rooms',
                            },
                            {
                              '@>': [
                                {
                                  '@$': '$value',
                                },
                                'sqft',
                              ],
                            },
                          ],
                        },
                      },
                      tdcDensity: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    1,
                                  ],
                                },
                                0,
                              ],
                            },
                            {
                              '??': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'projects',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'tdc',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                          ],
                          {
                            '/': [
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'tdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  1,
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      mtdcDensity: {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '??': [
                                    {
                                      '+': {
                                        '->': [
                                          {
                                            '@': 'rooms',
                                          },
                                          {
                                            '@>': [
                                              {
                                                '@$': '$value',
                                              },
                                              'asf',
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                    1,
                                  ],
                                },
                                0,
                              ],
                            },
                            {
                              '??': [
                                {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'projects',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          'mtdc',
                                        ],
                                      },
                                    ],
                                  },
                                },
                                0,
                              ],
                            },
                          ],
                          {
                            '/': [
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'projects',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'mtdc',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  0,
                                ],
                              },
                              {
                                '??': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'rooms',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'asf',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  1,
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      utilization: {
                        '/': [
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'asf',
                                  ],
                                },
                              ],
                            },
                          },
                          {
                            '+': {
                              '->': [
                                {
                                  '@': 'rooms',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'sqft',
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                      overflowActions: {
                        '[]': [
                          {
                            '{}': {
                              icon: 'atn-icon atn-link',
                              action: {
                                '{}': {
                                  payload: {
                                    '{}': {
                                      goto: {
                                        '{}': {
                                          variables: {
                                            '{}': {
                                              orgEntityId: {
                                                '@_': 'id',
                                              },
                                              orgRecordId: {
                                                '@.': '!id',
                                              },
                                            },
                                          },
                                          navigationId: 'explore',
                                        },
                                      },
                                    },
                                  },
                                  operation: 'ui.navigate',
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  subqueries: {
                    rooms: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!space',
                      },
                      using: 'orgSpace',
                      filter: {
                        and: [
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'spaceEntityId',
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                '=': [
                                  {
                                    '@^': {
                                      '``': {
                                        '@$': 'spaceEntityId',
                                      },
                                    },
                                  },
                                  {
                                    '``': {
                                      '@$': 'spaceRecordId',
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'spaceType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@.': [
                                      '!space_use',
                                      {
                                        ref: {
                                          entity: '!group',
                                        },
                                      },
                                    ],
                                  },
                                  {
                                    '@>': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'spaceType',
                                          },
                                        },
                                      },
                                      'ent:!space_use:!group',
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      target: 'ent:!space:!room',
                      selection: {
                        '{}': {
                          asf: {
                            '*': [
                              {
                                '@.': '!sqft',
                              },
                              {
                                '/': [
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '*': [
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'value',
                                              ],
                                            },
                                            {
                                              '@>': [
                                                {
                                                  '@$': '$value',
                                                },
                                                'allowable',
                                              ],
                                            },
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    '+': {
                                      '->': [
                                        {
                                          '@': 'weights',
                                        },
                                        {
                                          '@>': [
                                            {
                                              '@$': '$value',
                                            },
                                            'value',
                                          ],
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                          sqft: {
                            '@.': '!sqft',
                          },
                        },
                      },
                      subqueries: {
                        weights: {
                          ref: {
                            attr: 'attr:ent#!space_funcl#!entry:!space',
                            inherit: '-',
                          },
                          filter: {
                            '!=': [
                              {
                                '@.': '!weight',
                              },
                              0,
                            ],
                          },
                          target: 'ent:!space_funcl:!entry',
                          selection: {
                            '{}': {
                              value: {
                                '@.': '!weight',
                              },
                              allowable: {
                                if: [
                                  [
                                    {
                                      '!=': [
                                        {
                                          '@': 'funcIdCat',
                                        },
                                        null,
                                      ],
                                    },
                                    1,
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            funcIdCat: {
                              ref: {
                                attr: 'attr:ent#!space_funcl#!entry:!func_space',
                              },
                              target: 'ent:!func_space:!func',
                              selection: {
                                '@.': [
                                  '!func_idc',
                                  {
                                    ref: {
                                      entity: '!cat',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                    orgSpace: {
                      ref: {
                        attr: 'attr:ent#!org_space#!entry:!org',
                        inherit: '-',
                      },
                      target: 'ent:!org_space:!entry',
                    },
                    projects: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      filter: {
                        not: {
                          '=': [
                            {
                              '@': 'projectPiAssignments',
                            },
                            null,
                          ],
                        },
                      },
                      target: 'ent:!projects:!proj',
                      selection: {
                        '{}': {
                          tdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'tdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                          mtdc: {
                            '+': {
                              '->': [
                                {
                                  '@': 'projectGlExpenses',
                                },
                                {
                                  '@>': [
                                    {
                                      '@$': '$value',
                                    },
                                    'mtdcAmount',
                                  ],
                                },
                              ],
                            },
                          },
                        },
                      },
                      subqueries: {
                        projectGlExpenses: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '{}': {
                              idcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'IDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              tdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'TDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                              mtdcAmount: {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '@': 'costType',
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@.': '!amount',
                                    },
                                  ],
                                  0,
                                ],
                              },
                            },
                          },
                          subqueries: {
                            costType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!code',
                              },
                            },
                          },
                        },
                        projectPiAssignments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          filter: {
                            and: [
                              {
                                not: {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'piRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                              },
                              {
                                '=': [
                                  {
                                    '``': {
                                      '@$': 'piRecordId',
                                    },
                                  },
                                  {
                                    '@.': [
                                      '!pi',
                                      {
                                        ref: {
                                          entity: '!employee',
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          target: 'ent:!proj_pis:!entry',
                        },
                        projectPiDepartments: {
                          ref: {
                            attr: 'attr:ent#!proj_pis#!entry:!proj',
                          },
                          target: 'ent:!proj_pis:!entry',
                          selection: {
                            '@': 'piDept',
                          },
                          subqueries: {
                            piDept: {
                              ref: {
                                attr: 'attr:ent#!proj_pis#!entry:!pi',
                              },
                              target: 'ent:!personnel:!employee',
                              selection: {
                                '@.': [
                                  '!org',
                                  {
                                    ref: {
                                      entity: '!dept',
                                    },
                                  },
                                ],
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  variables: {
    focusedRange: {
      $range: {
        end: {
          $date: '12/31/2024',
        },
        start: {
          $date: '1/1/2024',
        },
      },
    },
  },
}
